import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import styled, { createGlobalStyle } from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import { Box, Header as ModalHeader, Title as ModalTitle, Content as ModalContent } from '@spa/shared/components/Modal/styles';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
export var GlobalModalStyle = /*#__PURE__*/createGlobalStyle([".gender-restriction{border-radius:", ";", "{", " ", " ", " ", "}", "{padding:", ";padding-bottom:", ";", "}", "{display:flex;flex-direction:column;", ";", "}}"], function (props) {
  return props.theme.space(2);
}, Box, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          height: auto;\n          width: 60%;\n        "]))), mediaMin.smallBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          width: 80%;\n        "]))), mediaMin.extraSmallBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          width: 100%;\n          margin: 0 ", ";\n        "])), function (props) {
  return props.theme.space(8);
}), mediaMin.compactPhoneBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          margin: 0 ", ";\n        "])), function (props) {
  return props.theme.space(6);
}), ModalHeader, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(4);
}, mediaMin.smallBreakpoint(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          ", " {\n            margin: 0;\n          }\n        "])), ModalTitle), ModalContent, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
}, mediaMin.smallBreakpoint(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          ", ";\n          \n          height: 100%;\n          padding: ", ";\n          padding-top: ", ";\n        "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6, 'column');
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(4);
}));
export var Actions = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1lnesfq-0"
})(["display:flex;flex-direction:row;", ";", " ", "{padding:", ";flex-grow:1;font-size:", ";line-height:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2);
}, mediaMin.smallBreakpoint(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    ", ";\n\n    margin: 0 ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.space(6);
}), Button, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(24);
});
export var Text = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1lnesfq-1"
})(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(24);
});